import type { captureException } from '@sentry/browser';

export type SentryContext = Parameters<typeof captureException>[1];

export class ErrorWithContext extends Error {
  sentryContext?: SentryContext;

  constructor(message: string, sentryContext?: SentryContext) {
    super(message);
    this.name = 'ErrorWithContext';
    this.sentryContext = sentryContext;

    // Fix prototype chain so instanceof works correctly
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
